module.exports = __webpack_public_path__ + "img/02焦点.c18eea35.png";